import { Component, Input, OnChanges } from '@angular/core';
import { SetComponentsService } from '../../../services/edit/set-components.service';
import { LayoutService } from '../../../services/layout.service';
import { SidenavContent } from '../../side-nav/sidenav-content';

@Component({
  selector: 'edit-c-embed',
  templateUrl: './edit-c-embed.component.html',
  styleUrls: ['./edit-c-embed.component.scss'],
})
export class EditCEmbedComponent extends SidenavContent implements OnChanges {
  @Input() embed: any;
  @Input() template: any;
  @Input() rowType: any;
  @Input() rowArray: any;
  @Input() compArray: any;
  @Input() edit: boolean;

  title: string;
  background = '';
  color = 'white';
  flushed: boolean;
  height: string;
  targetUrl = '';
  isCollapsed = true;

  private _temp: any;
  private _OneColumn: boolean;
  private _TwoColumns: boolean;
  private _ThreeColumns: boolean;
  private _FourColumns: boolean;
  private _FiveColumns: boolean;
  private _SixColumns: boolean;

  private _typeOf: any = 'embed';
  private _className: string;
  private _titleBack = '';

  constructor(
    private _layoutService: LayoutService,
    private _editService: SetComponentsService,
  ) {
    super(_layoutService);
  }

  ngOnChanges() {
    this._temp = this.template;
    if (this.edit === true) {
      this.setRowType();
      this.getFormVariables();
    } else {
      this.setNewVariables();
    }
    this.setRowType();
  }

  setNewVariables() {
    switch (this.rowType) {
      case 'col-2':
        this._className = 'height-250';
        this.title = '';
        this.background = '';
        this.color = '';
        this.flushed = true;
        this._titleBack = '';
        this.targetUrl = '';
        this.height = '215px';
        break;
      case 'col-21':
        //this.TwoColumns=true;
        this._className = 'height-250';
        this.title = '';
        this.background = '';
        this.color = '';
        this.flushed = true;
        this._titleBack = '';
        this.targetUrl = '';
        this.height = '215px';
        break;
      case 'col-2-1-2':
        this._className = 'height-250';
        this.title = '';
        this.background = '';
        this.color = '';
        this.flushed = true;
        this._titleBack = '';
        this.targetUrl = '';
        this.height = '215px';
        break;
      case 'col-2-1-3':
        this._className = 'height-250';
        this.title = '';
        this.background = '';
        this.color = '';
        this.flushed = true;
        this._titleBack = '';
        this.targetUrl = '';
        this.height = '215px';
        break;
      case 'col-2-2-1':
        this._className = 'height-250';
        this.title = '';
        this.background = '';
        this.color = '';
        this.flushed = true;
        this._titleBack = '';
        this.targetUrl = '';
        this.height = '215px';
        break;
      case 'col-2-3-1':
        this._className = 'height-250';
        this.title = '';
        this.background = '';
        this.color = '';
        this.flushed = true;
        this._titleBack = '';
        this.targetUrl = '';
        this.height = '215px';
        break;
      case 'col-31':
        this._className = 'height-250';
        this.title = '';
        this.background = '';
        this.color = '';
        this.flushed = true;
        this._titleBack = '';
        this.targetUrl = '';
        this.height = '100vh';
        break;
      case 'col-3-1-1-2':
        this._className = 'height-250';
        this.title = '';
        this.background = '';
        this.color = '';
        this.flushed = true;
        this._titleBack = '';
        this.targetUrl = '';
        // this.height = '100vh';
        this.height = '215px';
        break;
      case 'col-3-1-2-1':
        this._className = 'height-250';
        this.title = '';
        this.background = '';
        this.color = '';
        this.flushed = true;
        this._titleBack = '';
        this.targetUrl = '';
        // this.height = '100vh';
        this.height = '215px';
        break;
      case 'col-3-2-1-1':
        this._className = 'height-250';
        this.title = '';
        this.background = '';
        this.color = '';
        this.flushed = true;
        this._titleBack = '';
        this.targetUrl = '';
        // this.height = '100vh';
        this.height = '215px';
        break;
      case 'col-42':
        this._className = 'height-250';
        this.title = '';
        this.background = '';
        this.color = '';
        this.flushed = true;
        this._titleBack = '';
        this.targetUrl = '';
        this.height = '100vh';
        break;
      case 'col-421':
        this._className = 'height-250';
        this.title = '';
        this.background = '';
        this.color = '';
        this.flushed = true;
        this._titleBack = '';
        this.targetUrl = '';
        this.height = '100vh';
        break;
      case 'col-51':
        this._className = 'height-250';
        this.title = '';
        this.background = '';
        this.color = '';
        this.flushed = true;
        this._titleBack = '';
        this.targetUrl = '';
        this.height = '100vh';
        break;
      case 'col-632':
        this._className = 'height-250';
        this.title = '';
        this.background = '';
        this.color = '';
        this.flushed = true;
        this._titleBack = '';
        this.targetUrl = '';
        this.height = '100vh';
        break;
      default:
        this._className = 'padding-10';
        this.title = '';
        this.background = '';
        this.color = '';
        this.flushed = true;
        this._titleBack = '';
        this.targetUrl = '';
        this.height = '100vh';
    }
  }
  getFormVariables() {
    // Form Variables
    this._typeOf = 'embed'; // we force now to cta
    this.title = this._temp[this.compArray].title;
    this.background = this._temp[this.compArray].background;
    this.color = this._temp[this.compArray].color;
    this.flushed = this._temp[this.compArray].flushed;
    this._className = this._temp[this.compArray].className
      ? this._temp[this.compArray].className
      : this._className;
    this.targetUrl = this._temp[this.compArray].targetUrl;
    this.height = this._temp[this.compArray].height;
  }
  setRowType() {
    switch (this.rowType) {
      case 'col-2':
        this._TwoColumns = true;
        break;
      case 'col-21':
        this._TwoColumns = true;
        break;
      case 'col-2-1-2':
        this._TwoColumns = true;
        break;
      case 'col-2-1-3':
        this._TwoColumns = true;
        break;
      case 'col-2-2-1':
        this._TwoColumns = true;
        break;
      case 'col-2-3-1':
        this._TwoColumns = true;
        break;
      case 'col-31':
        this._ThreeColumns = true;
        break;
      case 'col-3-1-1-2':
        this._ThreeColumns = true;
        break;
      case 'col-3-1-2-1':
        this._ThreeColumns = true;
        break;
      case 'col-3-2-1-1':
        this._ThreeColumns = true;
        break;
      case 'col-42':
        this._FourColumns = true;
        break;
      case 'col-421':
        this._FourColumns = true;
        break;
      case 'col-51':
        this._FiveColumns = true;
        break;
      case 'col-632':
        this._SixColumns = true;
        break;
      default:
        this._OneColumn = true;
    }
  }

  updateEMBED() {
    let url = '';
    if (
      this.targetUrl.includes('http://') ||
      this.targetUrl.includes('http') ||
      this.targetUrl.includes('https')
    ) {
      if (this.targetUrl.includes('http://')) {
        url = this.targetUrl.replace('http://', 'https://');
        this.targetUrl = url;
      } else if (this.targetUrl.includes('https') && !this.targetUrl.includes('https://')) {
        url = this.targetUrl.replace('https', 'https://');
        this.targetUrl = url;
      } else if (
        this.targetUrl.includes('http') &&
        !this.targetUrl.includes('https://') &&
        !this.targetUrl.includes('http://')
      ) {
        url = this.targetUrl.replace('http', 'https://');
        this.targetUrl = url;
      }
    } else {
      url = 'https://' + this.targetUrl;
      this.targetUrl = url;
    }
    const result = {
      typeOf: 'embed',
      title: this.title,
      background: this.background,
      color: this.color,
      flushed: this.flushed,
      className: this._className,
      targetUrl: this.targetUrl,
      height: this.height,
    };
    this._editService.setEMBED(result, this.rowType, this._temp, this.rowArray, this.compArray);
  }
  submitEMBED() {
    let url = '';
    if (
      this.targetUrl.includes('http://') ||
      this.targetUrl.includes('http') ||
      this.targetUrl.includes('https')
    ) {
      if (this.targetUrl.includes('http://')) {
        url = this.targetUrl.replace('http://', 'https://');
        this.targetUrl = url;
      } else if (this.targetUrl.includes('https') && !this.targetUrl.includes('https://')) {
        url = this.targetUrl.replace('https', 'https://');
        this.targetUrl = url;
      } else if (
        this.targetUrl.includes('http') &&
        !this.targetUrl.includes('https://') &&
        !this.targetUrl.includes('http://')
      ) {
        url = this.targetUrl.replace('http', 'https://');
        this.targetUrl = url;
      }
    } else {
      url = 'https://' + this.targetUrl;
    }

    const result = {
      typeOf: 'embed',
      title: this.title,
      background: this.background,
      color: this.color,
      flushed: this.flushed,
      className: this._className,
      targetUrl: this.targetUrl,
      height: this.height,
    };
    this._editService.setEMBED(result, this.rowType, this._temp, this.rowArray, this.compArray);
    this.closeNav();
  }
  //   ---------------------------------------------------------------------------
  //   ------------------------------USER EXPERIENCE -----------------------------
  //   ---------------------------------------------------------------------------
}
